export default __webpack_public_path__ + "static/media/ADVIKA_pdf2.742a49ab.pdf";